import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { GenderStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type GenderQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const GenderQuizStep = ({ id, renderQuizScreen }: GenderQuizStepProps) => {
  const logger = useLogger();

  const { back, next, stepData, updateUserPreferences } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as GenderStepData;

  const goBack = async () => back();

  const onChosen = async (choice: string, answerKey?: string) => {
    updateUserPreferences(dataKey, choice);
    if (answerKey) {
      await next(choice, answerKey);
      return;
    }
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onChosen,
        onBack: goBack,
        ...(stepData as GenderStepData),
      })}
    </>
  );
};

export default GenderQuizStep;
